import { AdminInput, Div, isPartner, P } from '@vgrubs/components';
import { Dispatch, SetStateAction } from 'react';

export const BankInfo = ({
  routingNumber,
  setRoutingNumber,
  accountNumber,
  setAccountNumber,
  confirmAccountNumber,
  setConfirmAccountNumber,
}: {
  routingNumber: string;
  setRoutingNumber: Dispatch<SetStateAction<string>>;
  accountNumber: string;
  setAccountNumber: Dispatch<SetStateAction<string>>;
  confirmAccountNumber: string;
  setConfirmAccountNumber: Dispatch<SetStateAction<string>>;
}) => {
  return (
    <Div $flex $column $gap="24px">
      <P $m="0">Let's get {isPartner ? 'your' : 'this account'} bank info.</P>
      <AdminInput
        label="Routing Number"
        placeholder="Enter Here"
        value={routingNumber}
        onChange={({ target }) => setRoutingNumber(target.value)}
        $textCenter
      />
      <AdminInput
        label="Account Number"
        placeholder="Enter Here"
        value={accountNumber}
        onChange={({ target }) => setAccountNumber(target.value)}
        $textCenter
      />
      <AdminInput
        label="Confirm Account Number"
        placeholder="Enter Here"
        value={confirmAccountNumber}
        onChange={({ target }) => setConfirmAccountNumber(target.value)}
        $textCenter
      />
    </Div>
  );
};
